import type { AgentAccount, CreateAccountInput, LoginState , AgentProvider, ModelCatalog } from "@codvero/shared";
import { api, del, get, post } from "./client.ts";

export const modelsApi = {
  catalog: (provider: AgentProvider, account: string | null, refresh = false) => get<ModelCatalog>(`/api/models?provider=${provider}${account ? `&account=${account}` : ""}${refresh ? "&refresh=1" : ""}`),
};

export const accountsApi = {
  list: () => get<AgentAccount[]>("/api/accounts"),
  create: (input: CreateAccountInput) => post<AgentAccount>("/api/accounts", input),
  refresh: (id: string) => post<AgentAccount>(`/api/accounts/${id}/refresh`),
  setShared: (id: string, shared: boolean) => api<AgentAccount>(`/api/accounts/${id}/shared`, { method: "PUT", json: { shared } }),
  logout: (id: string) => post<AgentAccount>(`/api/accounts/${id}/logout`),
  remove: (id: string) => del(`/api/accounts/${id}`),
  loginStart: (id: string) => post<LoginState>(`/api/accounts/${id}/login/start`),
  loginState: (id: string) => get<LoginState | null>(`/api/accounts/${id}/login`),
  loginCode: (id: string, code: string) => post<LoginState>(`/api/accounts/${id}/login/code`, { code }),
  loginCancel: (id: string) => del(`/api/accounts/${id}/login`),
};
